import React from 'react';
import clsx from 'clsx';
import mime from 'mime-types';
import { Icon } from 'semantic-ui-react';

const UserDefinedAttachmentIcon = ({ outline, datasetCondition, isLoading }) => {
  let name = clsx('file', {
    outline,
    pdf: datasetCondition.context.attachmentType === mime.lookup('.pdf'),
    word: [mime.lookup('.docx'), mime.lookup('.doc')].includes(datasetCondition.context.attachmentType),
  });

  if (isLoading) {
    name = 'circle notched';
  }

  return <Icon name={name} loading={isLoading} />;
};

export default UserDefinedAttachmentIcon;
